<template>
    <div class="main">
        <noticetop/>
        <topback title="Transaction"></topback>
        <div class="content">
            <card color="#f3f3f6">
                <div slot="card-body">
                    <md-field class="assetslist">
                        <md-cell-item title="I Token" :addon="$store.state.userinfo.itoken">
                            <div class="holder" slot="left">
                                <iconimg name="i" class="assetslist-img"></iconimg>
                            </div>
                        </md-cell-item>
                    </md-field>
                    <div class="btngroup">
                        <div class="btnitem">
                            <iconimg name="inpaying" class="holder"></iconimg>
                            <span class="title">In transaction</span>
                            <span class="title">{{ $store.state.userinfo.inpay_quota }}</span>
                        </div>
                        <div class="btnitem">
                            <iconimg name="profit" class="holder"></iconimg>
                            <span class="title">Deal amount</span>
                            <span class="title">{{ $store.state.userinfo.total_success_amount }}</span>
                        </div>
                        <div class="btnitem">
                            <iconimg name="profit" class="holder"></iconimg>
                            <span class="title">Total profit</span>
                            <span class="title">{{ $store.state.userinfo.total_profit }}</span>
                        </div>
                    </div>
                    <md-cell-item title="Today Profit" :addon="String($store.state.userinfo.today_profit)">
                        <div class="holder" slot="left">
                            <iconimg name="gift"></iconimg>
                        </div>
                    </md-cell-item>
                </div>
            </card>

            <div class="tablist">
                <md-tab-bar v-model="current" :items="items" @change="onTabChange"></md-tab-bar>
                <md-swiper ref="swiper" :autoplay="0" :is-prevent="false" :is-loop="false" :has-dots="false"
                    @before-change="onSwiperChange">
                    <md-swiper-item>
                        <md-field-item title="Payment Options" :plain="true" class="mt-3">
                            <span slot="right" @click="go_buy_tutorial">Buy Tutotial</span>
                            <div class="payment-options" slot="children">
                                <md-radio-box class="payment-options-radio" name="inr" v-model="recharge_method" label="INR"  icon-position="lt" v-if="inr_additional_reward.enable !== 'off'"  />
                                <md-radio-box class="payment-options-radio" name="usdt" v-model="recharge_method" label="USDT" v-if="usdt_buy_reward.enable !== 'off'" />
                            </div>
                        </md-field-item>

                        <md-input-item ref="inr_amount" v-model="amount" placeholder="Enter the amount" is-virtual-keyboard
                            virtual-keyboard-vm="myNumberKeyBoard" clearable class="mt-3" :error="amount_error"
                            v-if="recharge_method === 'inr' && inr_additional_reward.enable !== 'off'">
                            <span slot="left"> ₹ </span>
                            <div slot="right">
                                <span class="usdt-text">= {{ principal }} IToken</span>
                            </div>
                        </md-input-item>

                        <md-input-item ref="usdt_amount" v-model="amount" placeholder="Enter the quantity"
                            is-virtual-keyboard virtual-keyboard-vm="myNumberKeyBoard" clearable class="mt-3"
                            :error="amount_error" v-if="recharge_method === 'usdt' && usdt_buy_reward.enable !== 'off'">
                            <iconimg name="usdt" slot="left"></iconimg>
                            <div slot="right">
                                <span class="usdt-text">≈ {{ principal }} IToken</span>
                            </div>
                        </md-input-item>

                        <md-number-keyboard type="professional" ref="myNumberKeyBoard" ok-text="Ok"></md-number-keyboard>
                        <p class="reward-text mt-3">
                            Estimated Reward Itoken: {{ reward }} ({{ $store.state.userinfo.payee_reward_ratio }}%: {{
                                principal_reward }})
                        </p>
                        <p class="reward-text mt-3" v-if="activity_award > 0"> Activity Award {{ activity_award }} USDT <span class="sii-gift">≈ {{ activity_award * exchangerate }} IToken</span>
                        </p>

                        <p class="reward-text mt-3"> You will receive: {{ get_itoken }} Itoken </p>
                        <div class="inbtn">
                            <md-button type="primary" class="mt-3" @click="confirm_buy"> Confirm Buy </md-button>
                        </div>

                        <p class="free-text mt-3">Exchange is free of charge.</p>
                    </md-swiper-item>
                    <md-swiper-item>
                        <md-field-item title="Sell mode" :plain="true" class="mt-3">
                            <div class="payment-options" slot="children">
                                <md-radio-box class="payment-options-radio" name="entrust" v-model="sell_method"
                                    label="Entrust" icon-position="lt" />
                                <md-radio-box class="payment-options-radio" name="manual" v-model="sell_method"
                                    label="Manual" />
                            </div>
                        </md-field-item>

                        <md-field-item>
                            <div slot="default">
                                <div class="usdt-text" v-if="sell_method === 'entrust'">
                                    <p>Sell your itoken automatically</p>
                                    <p>keeps your assets safe</p>
                                    <p>Entrust the sell of itoken, no transaction fee</p>
                                </div>
                                <div class="usdt-text" v-else>
                                    <p>Sell your iToken, will match you with the best buyers!</p>
                                    <p>Manually sell itoken, need to charge transaction fee</p>
                                </div>
                            </div>
                        </md-field-item>

                        <div v-if="sell_method === 'entrust'">
                            <md-cell-item :title="availablect_text" brief="Active UPI KYC Partner">
                                <span slot="right" @click="go_manage_kyc">
                                    Manage upi kyc partner
                                </span>
                            </md-cell-item>
                            
                            <md-cell-item :title="availablebank_text" brief="Active Bank KYC Partner">
                                <span slot="right" @click="go_manage_bankkyc">
                                    Manage bank kyc partner
                                </span>
                            </md-cell-item>

                            <div class="inbtn">
                                <md-button type="primary" class="mt-3" @click="start_entrust">{{ sell_btn }}</md-button>
                            </div>
                        </div>
                        <div v-else>

                        </div>
                    </md-swiper-item>

                </md-swiper>
            </div>
        </div>
        <navbar></navbar>
    </div>
</template>

<script>
import topback from '@/components/topback'
import navbar from '@/components/navbar'
import goodscard from '@/components/goodscard'
import pointtext from '@/components/pointtext'
import iconimg from '@/components/iconimg'
import card from '@/components/card'
import { Dialog } from 'mand-mobile'
import noticetop from '@/components/noticetop'
import { getcwexchangerate, getavailablect, getavailablebank } from '@/request/api'

export default {
    name: 'transaction',
    components: {
        [topback.name]: topback,
        [navbar.name]: navbar,
        [goodscard.name]: goodscard,
        [pointtext.name]: pointtext,
        iconimg,
        card,
        noticetop
    },
    data() {
        return {
            current: 0,
            items: [{ name: 0, label: 'Buy' }, { name: 1, label: 'Sell' }],
            recharge_method: "inr",
            amount: "",

            exchangerate: 90,
            min_reward_usdt: 100,
            principal_reward: 0,
            reward: 0,
            get_itoken: 0,
            gift: 0,
            principal: 0,
            amount_error: "",
            inr_additional_reward: {},
            activity_award: 0,
            usdt_buy_reward: {},


            sell_method: "entrust",
            availablect_count: 0,
            availablect_text: "In Active: 0",
            availablepay_count: 0,
            availablebank_text: "In Active: 0",
            sell_btn: "Start Sell",
            sell_c2c_btn: "Start Sell",
        }
    },
    watch: {
        amount(newVal) {
            if (newVal <= 0) {
                this.amount_error = "incorrect amount";
                this.reward = 0;
                this.get_itoken = 0;
                this.gift = 0;
                this.principal = 0;
                return;
            } else {
                this.amount_error = "";
                this.activity_award = 0;
                this.calculate_itoken(newVal);
            }
        },
        recharge_method(newVal, oldVal) {
            this.amount_error = "";
            this.reward = 0;
            this.get_itoken = 0;
            this.gift = 0;
            this.principal = 0;
            this.amount = "";
        },
        sell_method(newVal, oldVal) {
            if (newVal === 'entrust') {
                this.get_availablect_count();
                this.getavailablebank_count();
            }
        },
    },
    created() {
        this.get_cwexchangerate();
        this.$store.dispatch("asyncupdateuserinfo").then(res => {
            this.in_sell_btn(res);
        });
        this.get_availablect_count();
        this.getavailablebank_count();
        this.$store.dispatch("asyncupdatesiteconfig");
    },
    mounted() {
        this.$nextTick(() => {
            const footerNavHeight = this.$el.querySelector('.footer_nav').offsetHeight;
            this.$el.querySelector('.content').style.paddingBottom = footerNavHeight + 'px';
        });
    },
    methods: {
        go_tg_channel() {
            window.location.href = this.$store.state.siteconfig.tg_channel_link;
        },
        in_sell_btn(userinfo) {
            if (userinfo.sell) {
                this.sell_btn = "In Sell";
            }
        },
        start_entrust() {
            if (this.$store.state.userinfo.in_sell) {
                this.$router.push('/sell');
                return;
            }
            let that = this;
            if (this.availablect_count === 0) {
                Dialog.confirm({
                    title: 'Tips',
                    content: 'Please activate your kyc partner before entrusting the sale',
                    cancelText: 'Cancel',
                    confirmText: 'Ok',
                    onConfirm: () => console.log('[Dialog.confirm] confirm clicked'),
                })
                return;
            }
            that.$router.push('/sell');
        },
        confirm_buy() {
            if (Number(this.amount) <= 0 || this.amount_error !== '') {
                this.$toast.failed("incorrect amount");
                return;
            }
            if (this.recharge_method === 'usdt') {
                // usdt method
                if(Number(this.amount) < Number(this.usdt_buy_reward.recharge_min_amount || 0)) {
                    this.$toast.failed(`Min Deposit: ${this.usdt_buy_reward.recharge_min_amount} USDT`);
                    return;
                }
                this.$router.push('/depositusdt/' + this.amount + "/" + this.get_itoken);
            } else {
                if(Number(this.amount) < Number(this.inr_additional_reward.recharge_min_amount || 0)) {
                    this.$toast.failed(`Min Deposit: ${this.inr_additional_reward.recharge_min_amount} INR`);
                    return;
                }
                this.$router.push('/buyitokeninr/' + this.amount);
            }
        },
        calculate_itoken(newVal) {
            newVal = Number(newVal);
            if (this.recharge_method === 'usdt') {
                // usdt
                if (newVal >= Number(this.min_reward_usdt)) {
                    this.gift = 1 * this.exchangerate;
                } else {
                    this.gift = 0;
                }
                this.principal = newVal * this.exchangerate;
                let principal_reward = newVal * Number(this.$store.state.userinfo.payee_reward_ratio) * Number("0.01") * this.exchangerate;
                this.principal_reward = principal_reward.toFixed(2);
                this.reward = principal_reward + this.gift;
                if (this.usdt_buy_reward.mode == "fixed") {
                    this.activity_award += Number(this.usdt_buy_reward.fixed);
                } else if (this.usdt_buy_reward.mode == "ratio" && this.usdt_buy_reward.ratio > 0) {
                    this.activity_award += Number(this.usdt_buy_reward.ratio) * Number("0.01") * newVal;
                }
                if (this.usdt_buy_reward.additional.activate) {
                    //rule: {100: 1, 500: 2, 1000: 3, 2000: 7, 3000: 10, 4000: 14, 99999999: 14}
                    let rule = this.usdt_buy_reward.additional.rule;
                    let rule_keys = Object.keys(rule);
                    let rule_values = Object.values(rule);
                    let rule_index = -1;
                    for (let i = 0; i < rule_keys.length; i++) {
                        if (newVal > Number(rule_keys[i])) {
                            rule_index = i;
                        }
                    }
                    if (rule_index >= 0) {
                        this.activity_award += Number(rule_values[rule_index ]);
                    }
                }
                this.get_itoken = this.principal + this.reward + this.activity_award * this.exchangerate ;

            } else {
                // inr
                let mode_set = this.inr_additional_reward;
                this.principal = newVal;
                let principal_reward = newVal * Number(this.$store.state.userinfo.payee_reward_ratio) * Number("0.01");
                if (mode_set.mode === 'ratio') {
                    this.gift = newVal * Number(mode_set.ratio) * Number("0.01");
                } else {
                    this.gift = Number(mode_set.fixed);
                }
                this.principal_reward = principal_reward.toFixed(2);
                this.reward = (principal_reward + this.gift).toFixed(2);
                this.get_itoken = this.principal + Number(this.reward);
            }
        },
        onSwiperChange(from, to) {
            this.current = to;
        },
        onTabChange(item, index) {
            this.$refs.swiper.goto(index)
        },
        get_cwexchangerate() {
            getcwexchangerate().then(res => {
                let defaultbuy = res.data.default;
                if( defaultbuy === 'usdt') {
                    this.recharge_method = 'usdt';
                } else if( defaultbuy === 'inr') {
                    this.recharge_method = 'inr';
                }
                this.exchangerate = res.data.usdt_exchangerate;
                this.min_reward_usdt = res.data.usdt_buy_reward.min_reward_usdt;
                this.usdt_buy_reward = res.data.usdt_buy_reward;
                this.inr_additional_reward = res.data.inr_buy_reward;
            })
        },
        go_manage_kyc() {
            this.$router.push('/kycpartner');
        },
        go_manage_bankkyc() {
            this.$router.push('/banks');
        },
        go_manage_payment_methods() {
            this.$router.push('/paymentmethods');
        },
        go_buy_tutorial() {
            if (this.recharge_method === 'usdt') {
                this.$router.push('/newdedetailcode/' + 'usdtbuytutorial');
            } else {
                this.$router.push('/newdedetailcode/' + 'inrbuytutorial');
            }
        },
        get_availablect_count() {
            getavailablect({ purpose: 'payee', payment_method: 'upi' }).then(res => {
                if (res.code === 200) {
                    this.isSelectorShow = true;
                    if (res.data.length !== 0) {
                        this.availablect_text = "In Active: " + res.data.length;
                        this.availablect_count = res.data.length;
                    }
                }
            })
        },
        getavailablebank_count() {
            getavailablebank().then(res=>{
                if(res.code === 200) {
                    this.availablebank_text = "In Active: " + res.data.available_count;
                }
            })
        }
    }
}
</script>


<style scoped>
.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}

.free-text {
    color: #4a4a4a;
    font-size: 0.18rem;
    text-align: center;
}

.reward-text {
    font-size: 0.2rem;
    color: red;
}

.usdt-text {
    color: #f0b90b;
}

.payment-options {
    display: flex;
    justify-content: center;
    align-items: center;
}

.payment-options-radio {
    flex-basis: 100px;
    flex-grow: 1;
    margin: 0 10px;
}

.btngroup .holder {
    margin: 10px auto;
    display: block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.holder {
    line-height: 0px;
    font-size: 39px;
}

.btnitem .title {
    font-size: 0.26rem;
    margin: 0.05rem;
}

.btngroup {
    margin: 0.2rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.btngroup .btnitem {
    text-align: center;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: calc(90% / 3);
    height: calc(90% / 3);
    border-radius: 20px;
    box-shadow: 0 8px 12px #ebedf0;
    overflow: auto;
}

.assetslist-img {
    width: 0.42rem;
}

.assetslist .holder {
    line-height: 0px;
    font-size: 39px;
}

.assetslist-img {
    width: 0.42rem;
}

.assetslist>>>.md-cell-item-right {
    color: black;
}

.md-card-button {
    color: #198cff;
    display: inline-block;
    padding: 0.07rem 0.07rem;
    background: #198cff;
    position: relative;
    background: 0 0;
    border-radius: 0.16rem;
    border: 3px solid #198cff;
}

.main {
    margin-top: 1rem;
}

.goodscard-group {
    background: #f3f3f6;
    margin: 10px 0;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}

.cell-group {
    background: #232b63;
    margin: 10px 16px;
    border-radius: 20px;
    overflow: hidden;
    padding: 20px;
}

.cell-group>>>.md-cell-item-title {
    color: #f9fafb !important;
}

.cell-group>>>.md-cell-item-body.multilines:before {
    content: none !important;
}

.header-slot {
    padding: 40px 0 20px 0;
}

.header-slot .title {
    color: #111A34;
    font-size: 60px;
    font-family: Songti SC;
    line-height: 1;
}

.header-slot .desc {
    margin-top: 16px;
    color: #858B9C;
    font-size: 26px;
}

.md-field {
    padding: 0rem 0.4rem 0 0.4rem;
}

.intrust-item {
    font-size: 0.26rem;
}

.intrust-item>>>.batch {
    color: black;
}

.intrust-item .batchd {
    margin-left: -9px;
}

.intrust-item .completion {
    margin-left: -0.19rem;
}

.intrust-item .price {
    color: black;
    font-size: 0.3rem;
}

.intrust-item .price .price-text {
    color: #2c3e50;
    font-size: 0.2rem;
}

.intrust-item .price .amount {
    font-weight: 200;
    font-size: 0.3rem;
}

.intrust-item div {
    margin: 4px;
}

.sii-gift {
    color: gold;
}

.tablist>>>.md-tab-bar-end {
    height: unset !important;
}

.inbtn {
    margin: 0 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/views/transaction.vue